import MainLayout from "@/layouts/MainLayout";

const TermsOfUse = () => {
  return (
    <MainLayout
      title="Terms of Use - Niumora"
      description="Our terms of use outline the rules and guidelines for using our website and services."
      keywords="terms of use, terms and conditions, legal, Niumora"
      ogType="article"
    >
      <div className="container max-w-4xl mx-auto px-4 py-16 md:py-24">
        <h1 className="text-4xl font-bold mb-8">Terms of Use</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-lg mb-8">Effective Date: March 29, 2025</p>

          <p className="mb-8">
            Welcome to <strong>Niumora</strong>. These Terms of Use ("Terms") govern your use of our website{" "}
            <a href="https://niumora.com" className="text-primary hover:underline">https://niumora.com</a>{" "}
            ("Website"). By accessing or using our Website, you agree to be bound by these Terms. If you do not agree, you must not use our Website.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. About Us</h2>
            <p>
              This Website is operated by <strong>Niumora Ltd</strong>, a company registered in the United Kingdom. We provide digital consultancy, training, and AI-powered business services. If you have any questions about these Terms, please contact us at:{" "}
              <a href="mailto:privacy@niumora.com" className="text-primary hover:underline">privacy@niumora.com</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Use of the Website</h2>
            <p className="mb-4">
              You agree to use the Website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment.
            </p>
            <p className="mb-4">You must not:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Use the Website in any way that breaches any applicable local, national, or international law or regulation</li>
              <li>Transmit or upload any viruses, malware, or harmful material</li>
              <li>Attempt to gain unauthorised access to the Website or any server or system connected to it</li>
              <li>Copy, scrape, or commercially exploit content from our Website without permission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Intellectual Property</h2>
            <p className="mb-4">
              Unless otherwise stated, all content on this Website — including text, graphics, logos, images, videos, and software — is the property of Niumora Ltd or its content suppliers and is protected by UK and international copyright laws.
            </p>
            <p className="mb-4">You may:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>View pages and download content for <strong>personal, non-commercial use</strong></li>
              <li>Share links to our content provided attribution is given</li>
            </ul>
            <p className="mb-4">You may not:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Reproduce, duplicate, copy, sell, or exploit any part of the Website without express written permission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Limitation of Liability</h2>
            <p className="mb-4">
              The Website is provided <strong>"as is"</strong> and <strong>"as available"</strong>. While we make reasonable efforts to ensure that the content is accurate and up to date, we make no representations, warranties or guarantees, express or implied, about:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>The accuracy, completeness, or reliability of the Website content</li>
              <li>That the Website will be uninterrupted, secure, or error-free</li>
            </ul>
            <p>
              To the extent permitted by law, Niumora Ltd will not be liable for any direct, indirect, or consequential loss or damage arising from the use or inability to use this Website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Third-Party Links</h2>
            <p>
              Our Website may contain links to third-party websites or resources. These links are provided for your convenience only. We are not responsible for the content, practices, or availability of any external sites.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. Any changes will be posted on this page and take effect immediately upon publication. We encourage you to check this page regularly.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to the Website if you breach these Terms or for any other reason at our sole discretion.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of <strong>England and Wales</strong>. Any disputes relating to these Terms will be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact:{" "}
              <a href="mailto:privacy@niumora.com" className="text-primary hover:underline">privacy@niumora.com</a>
            </p>
          </section>
        </div>
      </div>
    </MainLayout>
  );
};

export default TermsOfUse;
